import { useCallback, useEffect, useMemo, useState } from 'react';
import { determineDateRangeAfterZoomIn, generateResponsiveXTicks, isDefined, } from '../utils';
const useChartZoomUtils = (params) => {
    const { timePeriod, setTimePeriod, timezone, isMobile = false } = params;
    const [isZoomed, setIsZoomed] = useState(false);
    const [zoomStartTime, setZoomStartTime] = useState(timePeriod.fromDate.valueOf());
    const [zoomEndTime, setZoomEndTime] = useState(timePeriod.toDate.valueOf());
    const zoomReset = useCallback(() => {
        setZoomStartTime(timePeriod.fromDate.valueOf());
        setZoomEndTime(timePeriod.toDate.valueOf());
        setIsZoomed(false);
    }, [timePeriod]);
    useEffect(() => {
        let isMounted = true;
        if (isMounted)
            zoomReset();
        return () => {
            isMounted = false;
        };
    }, [timePeriod, zoomReset]);
    const zoomIn = (zoomRange) => {
        if (!zoomRange)
            return;
        const { from, to } = zoomRange;
        if (!isDefined(from) || !isDefined(to) || from === to) {
            // setZoomStartTime(timePeriod.fromDate.valueOf());
            // setZoomEndTime(timePeriod.toDate.valueOf());
            return;
        }
        const { fromDate: fromDateEpochMs, toDate: toDateEpochMs } = determineDateRangeAfterZoomIn(from, to);
        setZoomStartTime(fromDateEpochMs);
        setZoomEndTime(toDateEpochMs);
        setIsZoomed(true);
    };
    const xTicks = useMemo(() => {
        return generateResponsiveXTicks({
            fromDate: zoomStartTime,
            toDate: zoomEndTime,
            options: {
                ianaTimeZone: timezone,
            },
            isMobile,
        });
    }, [zoomStartTime, zoomEndTime, timezone, isMobile]);
    return {
        timePeriod,
        zoomStartTime,
        zoomEndTime,
        zoomIn,
        zoomReset,
        isZoomed,
        setTimePeriod,
        xTicks,
    };
};
/**
 * used for local independent charts (i.e. notification/incident charts) that don't use
 * global redux time filter
 */
export const useLocalChartUtils = (initialFromDate, initialToDate) => {
    const [refAreaStart, setRefAreaStart] = useState('');
    const [refAreaEnd, setRefAreaEnd] = useState('');
    const [chartFromDate, setChartFromDate] = useState(initialFromDate);
    const [chartToDate, setChartToDate] = useState(initialToDate);
    const zoomIn = useCallback(() => {
        if (refAreaStart === refAreaEnd ||
            refAreaStart === undefined ||
            refAreaEnd === undefined) {
            setRefAreaStart('');
            setRefAreaEnd('');
            return;
        }
        const { fromDate: fromDateMs, toDate: toDateMs } = determineDateRangeAfterZoomIn(+refAreaStart, +refAreaEnd);
        setChartFromDate(fromDateMs);
        setChartToDate(toDateMs);
        setRefAreaStart('');
        setRefAreaEnd('');
    }, [refAreaStart, refAreaEnd]);
    const onZoomReset = () => {
        setChartFromDate(initialFromDate);
        setChartToDate(initialToDate);
    };
    return {
        refAreaStart,
        setRefAreaStart,
        refAreaEnd,
        setRefAreaEnd,
        zoomIn,
        onZoomReset,
        chartFromDate,
        chartToDate,
    };
};
const initalRefAreaRange = {};
/**
 * Return refAreaRange and set method for reference area on the graph and
 * Return method for updating charts zoom range
 */
export const useRefArea = (zoomIn) => {
    // const { zoomIn } = params;
    const [refAreaRange, setRefAreaRange] = useState(initalRefAreaRange);
    const updateZoomRange = useCallback(() => {
        if (refAreaRange.from && refAreaRange.to)
            zoomIn({ from: refAreaRange.from, to: refAreaRange.to });
        setRefAreaRange(initalRefAreaRange);
    }, [refAreaRange, zoomIn]);
    const setRefAreaFrom = useCallback((val) => {
        setRefAreaRange(Object.assign(Object.assign({}, refAreaRange), { from: val }));
    }, [refAreaRange, setRefAreaRange]);
    const setRefAreaTo = useCallback((val) => {
        setRefAreaRange(Object.assign(Object.assign({}, refAreaRange), { to: val }));
    }, [refAreaRange, setRefAreaRange]);
    return {
        refAreaRange,
        setRefAreaRange,
        updateZoomRange,
        setRefAreaFrom,
        setRefAreaTo,
    };
};
export default useChartZoomUtils;
